// extracted by mini-css-extract-plugin
module.exports = {"component2":"PropertyDropdown-module__component2--J_VLz"};